import React from "react"
import {FieldControlViewProps} from "../../../../render/control-view"
import FieldSelectField from "../select-group-field"
import GroupBy from "../../../../../gd/manager/group-by/group-by-model"
import DateGrouping_getGroupLabel from "../../../../system/task/date/functions/get-group-label"
import ControlButtonStandard from "../../../../../gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../../gd-components/buttons/control-button/@types"

type State = {
    showPopover: boolean
}

// const debug = "FieldSelectGroupField_ControlView"
const debug = false

export default class FieldSelectGroupField_ControlView extends React.Component<FieldControlViewProps, State> {

    constructor(props: FieldControlViewProps) {
        super(props)

        this.state = {
            showPopover: false
        }
    }

    showPopover = () => {
        this.setState({
            showPopover: true
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover: false
        })
    }

    onValueChange = (groupBy: GroupBy, hidePopover: boolean = true) => {
        debug && console.log(debug, "onValueChange", groupBy)

        this.props.onChange?.(groupBy)
        if (hidePopover) this.hidePopover()
    }

    render() {
        const field: FieldSelectField = this.props.field as FieldSelectField
        const groupBy: GroupBy | undefined = field.getViewValue(this.props.model)

        const label = !groupBy?.field ? 'None' : DateGrouping_getGroupLabel(groupBy)

        const classes = Classes("s-28 p-l-6 p-r-6", this.props.className, {
            'show-popover': this.state.showPopover
        })

        debug && console.log(debug, 'render', groupBy, this.props)

        return (
            <ControlButtonStandard className        = {classes}
                                   size             = {ControlButtonSize.SIZE_28}
                                   selectedClass    = "hover-bg"
                                   isSelected       = {!!groupBy?.field}
                                   onClick          = {this.showPopover}>
                <div className="label txt-truncate ui5-txt-not-important-small">{label}</div>

                {this.state.showPopover &&
                    <field.components.PopoverMenu {...this.props} parent={this}/>
                }

            </ControlButtonStandard>
        )
    }
}